import * as utils from '@src/utils';

export default function ({Vue}) {

  Vue.prototype.$u = utils;
}
